﻿// This JavaScript file is created by Cision for all our modules.
// This is the first version of this file so far.
// This file works as a dictionary for all the modules and could be combined with all of them.

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};

cision.websolution.texts["sv"] = {
    // sharegraph translations
    TextComparison: "Jämförelser",
    TextIndicator: "Indikatorer",
    TextOption: "Alternativ",
    TextCompSubtitle: "Jämförelsetyp",
    TextViewSubtitle: "Visa vy",
    TextPercent: "Procent",
    TextNone: "Ingen Jämförelse",
    TextShowVolume: "Visa Volym",
    TextPartOfDay: "1D",
    TextEndOfDay: "Default Vy",
    TextReport: "Rapporter",
    TextPress: "Pressmeddelanden",
    TextIndex: "Index",
    TextPeers: "Konkurrenter",
    TextReleases: "Kurspåverkande Information",
    TextClose: "Stäng",
    TextIntra: "1D",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Å",
    TextInsider: "Insynshandel",
    TextDividend: "Utdelning",
    TextDownload: "Ladda ner",
    TextPrintChart: "Skriv ut graf",
    TextDownloadAsPNG: "Exportera som PNG",
    TextDownloadAsJPEG: "Exportera som JPEG",
    TextDownloadAsSVG: "Exportera som SVG",
    TextDownloadAsPDF: "Exportera som PDF",
    TextDownloadShareHistory: "Ladda ned historisk aktiedata",
    TextShareOptions: "Val för aktie",
    TextOrderBook: "Orderdjup",
    TextTrades: "Senaste avslut",
    TextPerformance: "Aktiedata",
    TextTotalReturn: "Total avkastning",
    TextIndicatorDisabledTooltip: "Detta val bör inte kombineras med volym",
    TextVolumeDisabledTooltip: "Detta val bör inte kombineras med kurspåverkande information",
    TextDelayInfo: "Kursinformationen är fördröjd med 15 minuter.",
    TextCredits: "Källa Cision/Millistream",
    TextShareCalculator: "Aktiekalkylator",

    // Insider translations
    TextInsiderTrans: "Insynshandel",
    TextInsiderPersons: "Insynspersoner",
    TextDate: "Datum",
    TextDateTime: "Datum och tid",
    TextBack: "Tillbaka",
    TextInsiderPerson: "Insynsperson",
    TextPosition: "Befattning",
    TextInstrument: "Värdepapper",
    TextTransaction: "Transaktion",
    TextFrom: "Från",
    TextTo: "Till",
    TextHoldings: "Innehav",
    TextSecurity: "Säkerhet",
    TextTransactions: "Transaktioner",
    TextLastTransaction: "Senaste Transaktion",
    TextHolder: "Innehavare",
    TextStatus: "Status",

    // other ir modules translations
    TextNumberRec: "Antal rekommendationer",
    TextHeader1: "Aktieinformation",
    TextHeader2: "Nuvarande distrubution av rekommendationer",
    TextLastUpdate: "Senast uppdaterad",
    TextName: "Namn",
    TextBuy: "Köp",
    TextStrongBuy: "Starkt köp",
    TextVolume: "Volym",
    TextSell: "Sälj",
    TextStrongSell: "Starkt sälj",
    TextHold: "Avvakta",
    TextMean: "Medelvärde",
    TextSymbol: "Symbol",
    TextCurrency: "Valuta",
    TextMarketPlace: "Marknadsplats",
    TextLatestPrice: "Senaste pris",
    TextClosingPrice: "Stängningspris",
    TextLatestChange: "Senaste förändring",
    TextLastChange: "Senast förändring",
    TextAtHigh: "Toppnotering",
    TextAtLast: "Lägsta notering",
    TextYearHigh: "Årshögsta",
    TextYearLow: "Årslägsta",
    TextNumberOfShares: "Antal aktier",
    TextShareValue: "Värde",

    TextShareCompute: "Beräkna",
    TextPurchaseDate: "Köp datum",
    TextShareType: "Aktie",
    TextShareTypeHelp: "Välj aktie att beräkna",
    TextShareSettings: "Inställningar",
    TextDownloadResultsAndShareHistory: "Ladda ner resultat och aktiehistorik",
    TextPeriodHelp: "Ange tidsperiod",
    TextYear: "År",
    TextMonth: "Månad",
    TextDay: "Dag",
    TextFromIncluding: "Från datum",
    TextToIncluding: "Till datum",
    TextNumberOfSharesHelp: "Ange antal aktier ELLER värdet av dina aktier",
    TextOpenPrice: "Öppningspris",
    TextChange: "Förändring",
    TextShareCalculatorResults: "Resultat",
    TextShareCalculatorHistory: "Historik",
    TextInitialInvestment: "Initial investering",
    TextEndValue: "Slutvärde",
    TextSharePrice: "Aktie pris",
    TextSharesBought: "Aktier köpta",
    TextAnnualizedChange: "Årlig förändring",
    TextEndOfTheDay: "Slutkurs",
    TextPartOfTheDay: "Senaste pris",
    TextNoTradesYet: "Det har inte skett någon handel ännu",

    TextPrice: "Pris",
    TextBuyer: "Köpare",
    TextSeller: "Säljare",
    TextTime: "Tid",
    TextAsk: "Sälj",
    TextBid: "Köp",
    TextHigh: "Högst",
    TextLow: "Lägst",
    TextTotal: "Totalt antal aktier",
    TextVotes: "Antal röster %",
    TextValue: "Värde",
    TextShare: "Aktie",
    TextHolders: "Aktieägare",
    TextValueSEK: "Värde i SEK",
    TextValueKSEK: "Värde i kSEK",
    TextArea: "Area Namn",
    TextOwnershipAreaNames: {
        'Sweden': 'SVERIGEBOENDE',
        'Usa': 'USA',
        'Nordic': 'ÖVRIGA NORDEN',
        'Europe': 'ÖVRIGA EUROPA',
        'World': 'ÖVRIGA VÄRLDEN',
        'Total': 'TOTAL'
    },
    TextOwnershipLargestSummary: {
        'SubTotal': 'SUB-TOTAL',
        'SubTotal_Nominees': 'FÖRVALTARREG',
        'SubTotal_Others': 'ÖVRIGA',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextTurnover: "Omsättning",
    TextMarket: "Totala börsvärdet",
    TextLatest: "Senaste",
    TextAnnual: "Årliga",
    TextQuarterly: "Kvartalsvisa",
    TextHistorical: "Historiska",
    TextRec: "Rekommendationer",
    TextHistoricalRec: "Historiska Rekommendationer",
    TextSME: "Estimeringarna samlas in och beräknas av <a href='https://www.infrontfinance.com/products/infront-professional-terminal-for-ir/' target='_blank'> Infront. </a> Beräkningarna är baserade på prognoser från svenska och internationella analytiker. Infront grundades 1994 och är den ledande nordiska konsensusuppskattningstjänsten som omfattar cirka 500 nordiska företag.  Medverkande är de ledande bankerna och mäklarna i Norden och internationella investmentbanker.",
    TextSource: "Källa",
    TextLargest: "Största Aktieägarna",
    TextRange: "Storleksklasser",
    TextDist: "Geografisk fördelning",
    TextGrouped: "Största Grupperade Aktieägarna",
    TextAnalyticsCount: "Antal analytiker",

    // general translations
    TextCompany: "Företag",
    TextAddress: "Adress",
    TextPostalCode: "Postkod",
    TextSubmit: "Skicka",
    TextCity: "Stad",
    TextCountry: "Land",
    TextQuantity: "Kvantitet",
    Languages: {
        sv: "Svenska",
        en: "Engelska",
        fi: "Finska",
        da: "Danska",
        no: "Norska",
        de: "Tyska",
        fr: "Franska",
        pt: "Portugisiska",
        nl: "Holländska"
    },
    TextAttachment: "Bilagor",
    TextWhenWhere: "Var och När",
    TextDigitalVersion: "Digital version",
    TextRequired: "Obligatoriska fält",
    TextFirstEvent: "Nästkommande händelse",
    TextEvents: "Händelser",
    TextEvent: "Händelse",
    TextAddToCal: "Lägg till i din kalender",
    TextUpcomingEvents: "Kommande händelser",
    TextEventArchive: "Arkiv",
    TextTitle: "Titel",
    TextPrintLang: "Tryckspråk",
    TextPrintLink: "Länk till digital version",
    TextPrintQuant: "Kvantitet att beställa",
    TextOrderPrint: "Beställ trycksaker",
    TextAll: "Allt",
    TextPrintOrderSuccessHeader: "Beställningen mottagen!",
    TextPrintOrderFailHeader: "Beställningen misslyckades!",
    TextPrintOrderFail: "Ett fel uppstod och din beställning har inte gått igenom. Var vänlig kontrollera alla uppgifter och försk igen.",
    TextPrintOrderSuccess: "Du har beställt följande trycksaker: "
};

//DPS = utdelning per aktie
//Sales = Omsättning
//EPS = Vinst per aktie
//EBIT = Rörelseresultat

cision.websolution.texts["en"] = {
    // Sharegraph translations
    TextComparison: "Comparisons",
    TextIndicator: "Indicators",
    TextOption: "Options",
    TextCompSubtitle: "Comparison Type",
    TextViewSubtitle: "Show View",
    TextPercent: "Percent",
    TextNone: "Price",
    TextShowVolume: "Show Volume",
    TextPartOfDay: "1D",
    TextEndOfDay: "Default View",
    TextReport: "Reports",
    TextPress: "Press Releases",
    TextIndex: "Index",
    TextPeers: "Peers",
    TextReleases: "Regulatory Information",
    TextClose: "Close",
    TextIntra: "1D",
    Text1V: "1W",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "All",
    TextInsider: "Insider",
    TextDividend: "Dividend",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",
    TextTotalReturn: "Total return",
    TextIndicatorDisabledTooltip: "This option should not be viewed at the same time as volume since they are overlapping in the graph",
    TextVolumeDisabledTooltip: "This option should not be viewed at the same time as any of the indicators since they are overlapping in the graph",
    TextDelayInfo: "Quotes are delayed 15 minutes.",
    TextCredits: "Source Cision/Millistream",
    TextShareCalculator: "Share calculator",

    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",
    TextStatus: "Status",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextValue: "Value",
    TextShare: "Share",
    TextHolders: "Share Holders",
    TextValueSEK: "Value in SEK",
    TextValueKSEK: "Value in kSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextOwnershipLargestSummary: {
        'SubTotal': 'SUB-TOTAL',
        'SubTotal_Nominees': 'NOMINEES',
        'SubTotal_Others': 'OTHERS',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='https://www.infrontfinance.com/products/infront-professional-terminal-for-ir/' target='_blank'>Infront. </a> The estimates are based on projections from Swedish and International Analysts. Founded in 1994, Infront is the leading Nordic consensus estimates service covering about 500 Nordic companies. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccessHeader: "Order successful!",
    TextPrintOrderFailHeader: "Order failed!",
    TextPrintOrderFail: "Something went wrong with your order. Please check what you have entered and try agian.",
    TextPrintOrderSuccess: "You have now ordered the following items: "

};

// dk, fi, no and de translations is not complete.

cision.websolution.texts["dk"] = {
    // Sharegraph translations
    TextComparison: "Sammenligninger",
    TextIndicator: "Indikatorer",
    TextOption: "Optioner",
    TextCompSubtitle: "Sammenligning",
    TextViewSubtitle: "Vis",
    TextPercent: "Procent",
    TextValue: "Værdi",
    TextNone: "Pris",
    TextShowVolume: "Vis volumen",
    TextPartOfDay: "Intraday",
    TextEndOfDay: "Standardvisning",
    TextReport: "Rapporter",
    TextPress: "Pressemeddelelser",
    TextIndex: "Indeks",
    TextPeers: "Sammenlignelige virksomheder",
    TextReleases: "Lovmæssig information",
    TextClose: "Luk",
    TextIntra: "Intraday",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "Alle",
    TextInsider: "Insider",
    TextDividend: "Udbytte",
    TextTotalReturn: "Total return",
    TextIndicatorDisabledTooltip: "This option should not be viewed at the same time as volume since they are overlapping in the graph",
    TextVolumeDisabledTooltip: "This option should not be viewed at the same time as any of the indicators since they are overlapping in the graph",
    TextDelayInfo: "Quotes are delayed 15 minutes.",
    TextCredits: "Source Cision/Millistream",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",
    TextShareCalculator: "Share calculator",

    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",
    TextStatus: "Status",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextShare: "Share",
    TextHolders: "Share Holders",
    TextValueSEK: "Value in SEK",
    TextValueKSEK: "Value in kSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextOwnershipLargestSummary: {
        'SubTotal': 'SUB-TOTAL',
        'SubTotal_Nominees': 'NOMINEES',
        'SubTotal_Others': 'OTHERS',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='https://www.infrontfinance.com/products/infront-professional-terminal-for-ir/' target='_blank'>Infront. </a> The estimates are based on projections from Swedish and International Analysts. Founded in 1994, Infront is the leading Nordic consensus estimates service covering about 500 Nordic companies. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccessHeader: "Order successful!",
    TextPrintOrderFailHeader: "Order failed!",
    TextPrintOrderFail: "Something went wrong with your order. Please check what you have entered and try agian.",
    TextPrintOrderSuccess: "You have now ordered the following items: "
};

cision.websolution.texts["no"] = {
    // Sharegraph translations
    TextComparison: "Sammenligninger",
    TextIndicator: "Indikatorer",
    TextOption: "Alternativer",
    TextCompSubtitle: "Sammenligningstype",
    TextViewSubtitle: "visning",
    TextPercent: "Prosent",
    TextValue: "Verdi",
    TextNone: "Pris",
    TextShowVolume: "Vis volum",
    TextPartOfDay: "I løpet av dagen",
    TextEndOfDay: "Standard visning",
    TextReport: "Rapporter",
    TextPress: "Pressemeldinger",
    TextShare: "Aksje",
    TextIndex: "Stikkordliste",
    TextPeers: "Likestilte",
    TextReleases: "Regulerende informasjon",
    TextClose: "Lukk",
    TextIntra: "I løpet av dagen",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "Alle",
    TextInsider: "Insider",
    TextDividend: "Utbytte",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",
    TextTotalReturn: "Total return",
    TextIndicatorDisabledTooltip: "This option should not be viewed at the same time as volume since they are overlapping in the graph",
    TextVolumeDisabledTooltip: "This option should not be viewed at the same time as any of the indicators since they are overlapping in the graph",
    TextDelayInfo: "Quotes are delayed 15 minutes.",
    TextCredits: "Source Cision/Millistream",
    TextShareCalculator: "Share calculator",

    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",
    TextStatus: "Status",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextHolders: "Share Holders",
    TextValueSEK: "Value in SEK",
    TextValueKSEK: "Value in kSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextOwnershipLargestSummary: {
        'SubTotal': 'SUB-TOTAL',
        'SubTotal_Nominees': 'NOMINEES',
        'SubTotal_Others': 'OTHERS',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='https://www.infrontfinance.com/products/infront-professional-terminal-for-ir/' target='_blank'>Infront. </a> The estimates are based on projections from Swedish and International Analysts. Founded in 1994, Infront is the leading Nordic consensus estimates service covering about 500 Nordic companies. Contributors are the leading banks and brokers in the Nordic area and international investment banks. ",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccessHeader: "Order successful!",
    TextPrintOrderFailHeader: "Order failed!",
    TextPrintOrderFail: "Something went wrong with your order. Please check what you have entered and try agian.",
    TextPrintOrderSuccess: "You have now ordered the following items: "
};

cision.websolution.texts["fi"] = {
    // Sharegraph translations
    TextComparison: "Vertailut",
    TextIndicator: "Indikaattorit",
    TextOption: "Vaihtoehdot",
    TextCompSubtitle: "Vertailutyyppi",
    TextViewSubtitle: "Näytä näkymä",
    TextPercent: "Prosentti",
    TextValue: "Arvo",
    TextNone: "Hinta",
    TextShowVolume: "Näytä volyymi",
    TextPartOfDay: "Päiväkauppa",
    TextEndOfDay: "Oletusnäkymä",
    TextReport: "Raportit",
    TextPress: "Lehdistötiedotteet",
    TextShare: "Osake",
    TextIndex: "Indeksi",
    TextPeers: "Vertaisryhmään kuuluvat",
    TextReleases: "Sääntelytiedot",
    TextClose: "Sulje",
    TextIntra: "1PÄ",
    Text1V: "1VI",
    Text1M: "1KU",
    Text3M: "3KU",
    Text6M: "6KU",
    Text1Y: "1VU",
    TextAll: "Kaikki",
    TextInsider: "Sisäpiiriläinen",
    TextDividend: "Osinko",
    TextDownload: "Lataa",
    TextPrintChart: "Tulosta graafi",
    TextDownloadAsPNG: "Vie PNG:nä",
    TextDownloadAsJPEG: "Vie JPEG:nä",
    TextDownloadAsSVG: "Vie SVG:nä",
    TextDownloadAsPDF: "Vie PDF:nä",
    TextDownloadShareHistory: "Lataa kurssitieto",
    TextShareOptions: "Osakevalinnat",
    TextOrderBook: "Tilauskanta",
    TextTrades: "Viimeisimmät kaupat",
    TextPerformance: "Kaupankäyntitieto",
    TextDelayInfo: "Quotes are delayed 15 minutes.",
    TextCredits: "Source Cision/Millistream",
    TextShareCalculator: "Share calculator",

    // Insider translations
    TextInsiderTrans: "Sisäpiirin kaupat",
    TextInsiderPersons: "Sisäpiiriläiset",
    TextDate: "Päivämäärä",
    TextDateTime: "Päivämäärä ja aika",
    TextBack: "Takaisin",
    TextInsiderPerson: "Sisäpiiriläinen",
    TextPosition: "Asema",
    TextInstrument: "Instrumentti",
    TextTransaction: "Liiketoimi",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Omistukset",
    TextSecurity: "Security",
    TextTransactions: "Liiketoimet",
    TextLastTransaction: "Viimeisin liiketoimi",
    TextHolder: "Omistaja",
    TextTotalReturn: "Total return",
    TextIndicatorDisabledTooltip: "This option should not be viewed at the same time as volume since they are overlapping in the graph",
    TextVolumeDisabledTooltip: "This option should not be viewed at the same time as any of the indicators since they are overlapping in the graph",
    TextStatus: "Status",

    // other ir modules translations
    TextNumberRec: "Suositusten määrä",
    TextHeader1: "Osaketieto",
    TextHeader2: "Suositusten jakauma",
    TextLastUpdate: "Viimeisin päivitys",
    TextName: "Nimi",
    TextBuy: "Osta",
    TextStrongBuy: "Vahva osta",
    TextVolume: "Volyymi",
    TextSell: "Myy",
    TextStrongSell: "Vahva myy",
    TextHold: "Pidä",
    TextMean: "Keskiarvo",
    TextSymbol: "Tunnus",
    TextCurrency: "Valuutta",
    TextMarketPlace: "Markkinapaikka",
    TextLatestPrice: "Viimeisin hinta",
    TextClosingPrice: "Päätöskurssi",
    TextLatestChange: "Viimeisin muutos",
    TextLastChange: "Viimeisin muutos",
    TextAtHigh: "Kaikkien aikojen ylin",
    TextAtLast: "Kaikkien aikojen alin",
    TextYearHigh: "Vuoden ylin",
    TextYearLow: "Vuoden alin",
    TextNumberOfShares: "Osakkeiden lukumäärä",
    TextShareValue: "Arvo",

    TextShareCompute: "Laske",
    TextPurchaseDate: "Ostopäivämäärä",
    TextShareType: "Osaketyyppi",
    TextShareTypeHelp: "Valitse osaketyyppi",
    TextShareSettings: "Asetukset",
    TextDownloadResultsAndShareHistory: "Lataa tulos- ja osaketiedot",
    TextPeriodHelp: "Valitse aikaväli",
    TextYear: "Vuosi",
    TextMonth: "Kuukausi",
    TextDay: "Päivä",
    TextFromIncluding: "Alkaen",
    TextToIncluding: "Asti",
    TextNumberOfSharesHelp: "Syötä osakkeiden lukumäärä tai omistustesi arvo",
    TextOpenPrice: "Avauskurssi",
    TextChange: "Muutos",
    TextShareCalculatorResults: "Tulokset",
    TextShareCalculatorHistory: "Historia",
    TextInitialInvestment: "Alkuperäinen sijoitus",
    TextEndValue: "Päätösarvo",
    TextSharePrice: "Osakehinta",
    TextSharesBought: "Ostetut osakkeet",
    TextAnnualizedChange: "Annualisoitu muutos",
    TextEndOfTheDay: "Päivän päätös",
    TextPartOfTheDay: "Päivän osa",

    TextNoTradesYet: "Ei vielä kauppoja",
    TextPrice: "Hinta",
    TextBuyer: "Ostaja",
    TextSeller: "Myyjä",
    TextTime: "Aika",
    TextAsk: "Myynti",
    TextBid: "Osto",
    TextHigh: "Ylin",
    TextLow: "Alin",
    TextTurnover: "Liikevaihto",
    TextMarket: "Markkina-arvo",
    TextTotal: "Osakkeiden lukumäärä",
    TextVotes: "Äänet %",
    TextHolders: "Osakkeenomistajat",
    TextValueSEK: "Arvo SEK",
    TextValueKSEK: "Arvo kSEK",
    TextArea: "Aluenimi",
    TextOwnershipAreaNames: {
        'Sweden': 'RUOTSI',
        'Usa': 'USA',
        'Nordic': 'MUUT POHJOISMAAT',
        'Europe': 'MUU EUROOPPA',
        'World': 'MUU MAAILMA',
        'Total': 'YHTEENSÄ'
    },
    TextOwnershipLargestSummary: {
        'SubTotal': 'SUB-TOTAL',
        'SubTotal_Nominees': 'NOMINEES',
        'SubTotal_Others': 'OTHERS',
        'Total': 'YHTEENSÄ'
    },
    TextVoting: "Äänestysoikeudet",
    TextLatest: "Viimeisin",
    TextAnnual: "Vuosittainen",
    TextQuarterly: "Neljännesvuosittainen",
    TextHistorical: "Historiallinen",
    TextRec: "Suositukset",
    TextHistoricalRec: "Historialliset suositukset",
    TextSME: "The estimates are collected and calculated by <a href='https://www.infrontfinance.com/products/infront-professional-terminal-for-ir/' target='_blank'>Infront. </a> The estimates are based on projections from Swedish and International Analysts. Founded in 1994, Infront is the leading Nordic consensus estimates service covering about 500 Nordic companies. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Lähde",
    TextLargest: "Suurimmat osakkeenomistajat",
    TextRange: "Osakevaihtelut",
    TextDist: "Maantieteellinen jakauma",
    TextGrouped: "Suurimmat osakkeenomistajat ryhmiteltyinä",
    TextAnalyticsCount: "Analyytikot",

    // general translations
    TextCompany: "Yritys",
    TextAddress: "Osoite",
    TextPostalCode: "Postinumero",
    TextSubmit: "Lähetä",
    TextCity: "Kaupunki",
    TextCountry: "Maa",
    TextQuantity: "Määrä",
    Languages: {
        sv: "ruotsi",
        en: "englanti",
        fi: "suomi",
        de: "tanska",
        no: "norja",
        ge: "saksa",
        fr: "ranska",
        pt: "portugali",
        nl: "hollanti"
    },
    TextAttachment: "Liitteet",
    TextWhenWhere: "Missä ja milloin",
    TextDigitalVersion: "Digitaalinen versio",
    TextRequired: "Vaaditut kentät",
    TextFirstEvent: "Seuraava tapahtuma",
    TextEvents: "Tapahtumat",
    TextEvent: "Tapahtuma",
    TextAddToCal: "Lisää kalenteriisi",
    TextUpcomingEvents: "Tulevat tapahtumat",
    TextEventArchive: "Arkisto",
    TextTitle: "Otsikko",
    TextPrintLang: "Painokieli",
    TextPrintLink: "Linkki digitaaliseen versioon",
    TextPrintQuant: "Tilausmäärä",
    TextOrderPrint: "Tilaa tulostettuina",
    TextPrintOrderFailHeader: "Tilaus epäonnistui, ota yhteyttä asiakaspalveluun",
    TextPrintOrderSuccessHeader: "Olet tilannut seuraavat tuotteet",
    TextPrintOrderFail: "Something went wrong with your order. Please check what you have entered and try agian.",
    TextPrintOrderSuccess: "You have now ordered the following items: "
};

cision.websolution.texts["de"] = {
    // Sharegraph translations
    TextComparison: "Vergleiche",
    TextIndicator: "Indikatoren",
    TextOption: "Optionen",
    TextCompSubtitle: "Vergleichstyp",
    TextViewSubtitle: "Ansicht anzeigen",
    TextPercent: "Prozent",
    TextValue: "Wert",
    TextNone: "Preis",
    TextShowVolume: "Menge anzeigen",
    TextPartOfDay: "Intra Day",
    TextEndOfDay: "Standardansicht",
    TextReport: "Berichte",
    TextPress: "Pressemitteilungen",
    TextShare: "Aktie",
    TextIndex: "Index",
    TextPeers: "Fachkollegen",
    TextReleases: "Vorgeschriebene Information",
    TextClose: "Schließen",
    TextIntra: "Intraday",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "Alle",
    TextInsider: "Insider",
    TextDividend: "Dividende",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",
    TextTotalReturn: "Total return",
    TextIndicatorDisabledTooltip: "This option should not be viewed at the same time as volume since they are overlapping in the graph",
    TextVolumeDisabledTooltip: "This option should not be viewed at the same time as any of the indicators since they are overlapping in the graph",
    TextDelayInfo: "Quotes are delayed 15 minutes.",
    TextCredits: "Source Cision/Millistream",
    TextShareCalculator: "Share calculator",


    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",
    TextStatus: "Status",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextHolders: "Share Holders",
    TextValueSEK: "Value in SEK",
    TextValueKSEK: "Value in kSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextOwnershipLargestSummary: {
        'SubTotal': 'SUB-TOTAL',
        'SubTotal_Nominees': 'NOMINEES',
        'SubTotal_Others': 'OTHERS',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='https://www.infrontfinance.com/products/infront-professional-terminal-for-ir/' target='_blank'>Infront. </a> The estimates are based on projections from Swedish and International Analysts. Founded in 1994, Infront is the leading Nordic consensus estimates service covering about 500 Nordic companies. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccessHeader: "Order successful!",
    TextPrintOrderFailHeader: "Order failed!",
    TextPrintOrderFail: "Something went wrong with your order. Please check what you have entered and try agian.",
    TextPrintOrderSuccess: "You have now ordered the following items: "
};

/********* Datepicker specific texts. Needed for the sharegraph **************/

if ($.fn.datepicker) {
    $.fn.datepicker.dates['fi'] = {
        days: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
        daysShort: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        daysMin: ["su", "ma", "ti", "ke", "to", "pe", "la"],
        months: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
        monthsShort: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
        today: "Tänään",
        clear: "Tyhjennä",
        format: "yyyy-mm-dd",
        titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
        weekStart: 0
    };

    $.fn.datepicker.dates['sv'] = {
        days: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
        months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        today: "Idag",
        clear: "Rensa",
        format: "yyyy-mm-dd",
        titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
        weekStart: 0
    };
    $.fn.datepicker.dates['en'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: "Today",
        clear: "Clear",
        format: "yyyy-mm-dd",
        titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
        weekStart: 0
    };
    $.fn.datepicker.dates['no'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: "Today",
        clear: "Clear",
        format: "yyyy-mm-dd",
        titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
        weekStart: 0
    };
    $.fn.datepicker.dates['de'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: "Today",
        clear: "Clear",
        format: "yyyy-mm-dd",
        titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
        weekStart: 0
    };
    $.fn.datepicker.dates['dk'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: "Today",
        clear: "Clear",
        format: "yyyy-mm-dd",
        titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
        weekStart: 0
    };
}

/********* Calendar texts **************/

cision.websolution.texts["fi"].calendarTexts = {
    weekdays: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
    months: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
    shortMonths: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
    rangeSelectorFrom: ['From'],
    rangeSelectorTo: ['To'],
    downloadJPEG: ['Download JPEG image'],
    downloadPDF: ['Download PDF document'],
    downloadPNG: ['Download PNG image'],
    downloadSVG: ['Download SVG vector image'],
    printChart: ['Print chart'],
    source: ['Source']
};

cision.websolution.texts["en"].calendarTexts = {
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    rangeSelectorFrom: ['From'],
    rangeSelectorTo: ['To'],
    downloadJPEG: ['Download JPEG image'],
    downloadPDF: ['Download PDF document'],
    downloadPNG: ['Download PNG image'],
    downloadSVG: ['Download SVG vector image'],
    printChart: ['Print chart'],
    source: ['Source']
};

cision.websolution.texts["sv"].calendarTexts = {
    weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
    months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    rangeSelectorFrom: ['Från'],
    rangeSelectorTo: ['Till'],
    downloadJPEG: ['Ladda ner JPEG bild'],
    downloadPDF: ['Ladda ner PDF dokument'],
    downloadPNG: ['Ladda ner PNG bild'],
    downloadSVG: ['Ladda ner SVG bild'],
    printChart: ['Skriv ut graf'],
    source: ['Källa']
};


/********* Insider specific texts. Needed for insider transactions and sharegraph with insiders as indicators **************/

cision.websolution.texts["sv"].insidersDescriptions = function () {
    var transactionTypes = [];
    var positionTypes = [];
    var holderTypes = [];
    var securityTypes = [];
    var commentTypes = [];

    transactionTypes[0] = "Orsak okänd vid reg.";
    transactionTypes[1] = "Innehavsanmälan";
    transactionTypes[2] = "Köp";
    transactionTypes[3] = "Försäljning";
    transactionTypes[4] = "Korrigering upp";
    transactionTypes[5] = "Korrigering ned";
    transactionTypes[6] = "Omräkning +";
    transactionTypes[7] = "Omräkning -";
    transactionTypes[8] = "Förfall";
    transactionTypes[9] = "Tilldelning";
    transactionTypes[10] = "Aktiesparplan";
    transactionTypes[11] = "Teckning";
    transactionTypes[12] = "Bonus";
    transactionTypes[13] = "Återköp";
    transactionTypes[14] = "Gåva";
    transactionTypes[15] = "Start dispens";
    transactionTypes[16] = "Split";
    transactionTypes[17] = "Omvänd split";
    transactionTypes[18] = "Överföring";
    transactionTypes[19] = "Utfärdad option";
    transactionTypes[20] = "Ingående balans";
    transactionTypes[21] = "Konvertering";
    transactionTypes[22] = "Omstämpling";
    transactionTypes[23] = "Inlösen";
    transactionTypes[24] = "Aktielån";
    transactionTypes[25] = "Byte av värdepapper";
    transactionTypes[26] = "Nyemission";
    transactionTypes[27] = "Apportemission";
    transactionTypes[28] = "Arvsskifte";
    transactionTypes[29] = "Optionslösen";
    transactionTypes[30] = "Arv";
    transactionTypes[31] = "Slutdatum optioner";
    transactionTypes[32] = "Utdelning";
    transactionTypes[33] = "Fondemission";
    transactionTypes[34] = "Fusion";
    transactionTypes[35] = "Uttag";
    transactionTypes[36] = "Bodelning";
    transactionTypes[37] = "Ny närstående";
    transactionTypes[38] = "Vinst";
    transactionTypes[39] = "Sortbyte";
    transactionTypes[40] = "Utskiftning";
    transactionTypes[41] = "Uppköp";
    transactionTypes[42] = "Aktietermin";
    transactionTypes[43] = "Terminslösen";
    transactionTypes[44] = "Indragning";
    transactionTypes[45] = "Avyttring";
    transactionTypes[46] = "Interna överf VPC";
    transactionTypes[47] = "Återbetalning";
    transactionTypes[48] = "Omräkning";
    transactionTypes[49] = "Fission";
    transactionTypes[50] = "Utbyte";
    transactionTypes[51] = "Förlagslån";
    transactionTypes[52] = "Övrig förändring";
    transactionTypes[53] = "Avslut av insyn";

    commentTypes["makulerad"] = "Makulerad";
    commentTypes["reviderad"] = "Reviderad";


    holderTypes[1] = "Eget";
    holderTypes[2] = "Maka/Make";
    holderTypes[3] = "Jur person";
    holderTypes[4] = "Barn";
    holderTypes[5] = "Närstående";
    holderTypes[6] = "Sambo";


    positionTypes[1] = "VD";
    positionTypes[2] = "VD dotterbolag";
    positionTypes[3] = "VD moderföretag";
    positionTypes[4] = "Vice VD";
    positionTypes[5] = "Vice VD dotterbolag";
    positionTypes[6] = "Vice VD moderföretag";
    positionTypes[7] = "Styrelseledamot";
    positionTypes[8] = "Styrelseledamot dotterbol";
    positionTypes[9] = "Styrelseledamot moderftg";
    positionTypes[10] = "Styrelsesuppleant";
    positionTypes[11] = "Styrelsesuppl dotterbolag";
    positionTypes[12] = "Styrelsesuppl moderftg";
    positionTypes[13] = "Revisor";
    positionTypes[14] = "Revisor dotterbolag";
    positionTypes[15] = "Revisor moderftg";
    positionTypes[16] = "Revisorssuppleant";
    positionTypes[17] = "Revisorssuppl dotterbolag";
    positionTypes[18] = "Revisorssuppl moderftg";
    positionTypes[19] = "Större Innehavare";
    positionTypes[20] = "Annan befattning";
    positionTypes[21] = "Annan befattn dotterbolag";
    positionTypes[22] = "Annan befattn moderftg";
    positionTypes[23] = "Aktiemarknadsbolag";


    securityTypes[1] = "Aktie";
    securityTypes[2] = "Aktie  PR";
    securityTypes[3] = "Köpoption";
    securityTypes[4] = "Säljoption";
    securityTypes[5] = "Aktietermin";
    securityTypes[6] = "Syntetisk option";
    securityTypes[7] = "American depository receipts";
    securityTypes[8] = "Svenskt Depåbevis";
    securityTypes[9] = "Konvertibel";
    securityTypes[10] = "Betald tecknad aktie";
    securityTypes[11] = "Interimsaktie";
    securityTypes[12] = "Betald tecknad unit";
    securityTypes[13] = "Uniträtt";
    securityTypes[14] = "Teckningsrätt, aktie";
    securityTypes[15] = "Teckningsoption";
    securityTypes[16] = "Optionsbevis";
    securityTypes[17] = "Inlösenrätt";
    securityTypes[18] = "Speciell rätt";
    securityTypes[19] = "övriga derivat";
    securityTypes[20] = "Delbevis";
    securityTypes[21] = "Räntebärande värdepapper";
    securityTypes[22] = "Inlösenaktie";
    securityTypes[23] = "Konvertibelt vinstandelsbevis";
    securityTypes[24] = "Säljrätt";
    securityTypes[25] = "Interimsbevis";
    securityTypes[26] = "Delrätt, aktie";
    securityTypes[27] = "Betald tecknad konvertibel";
    securityTypes[28] = "Förlagslån";
    securityTypes[29] = "0-innehav";

    return {
        positionTypes: positionTypes,
        holderTypes: holderTypes,
        securityTypes: securityTypes,
        transactionTypes: transactionTypes,
        commentTypes: commentTypes
    };
}(jQuery);


cision.websolution.texts["en"].insidersDescriptions = function () {
    var transactionTypes = [];
    var positionTypes = [];
    var holderTypes = [];
    var securityTypes = [];
    var commentTypes = [];

    transactionTypes[0] = " Reason unknown at time of reg.";
    transactionTypes[1] = " Holding notification";
    transactionTypes[2] = "Purchase";
    transactionTypes[3] = "Sale";
    transactionTypes[4] = "Correction up";
    transactionTypes[5] = "Correction down";
    transactionTypes[6] = "Conversion +";
    transactionTypes[7] = "Conversion -";
    transactionTypes[8] = "Maturity";
    transactionTypes[9] = "Allotment";
    transactionTypes[10] = "Share investment plan";
    transactionTypes[11] = "Subscription";
    transactionTypes[12] = "Dividend";
    transactionTypes[13] = "Withdrawal";
    transactionTypes[14] = "Gift";
    transactionTypes[15] = "Exemption";
    transactionTypes[16] = "Split";
    transactionTypes[17] = "Reverse split";
    transactionTypes[18] = "Transfer";
    transactionTypes[19] = "Issued option";
    transactionTypes[20] = "Opening balance";
    transactionTypes[21] = "Conversion";
    transactionTypes[22] = "Reclassification";
    transactionTypes[23] = "Redemption";
    transactionTypes[24] = "Share loan";
    transactionTypes[25] = "Maturity";
    transactionTypes[26] = "New Share issue";
    transactionTypes[27] = "Issue in kind";
    transactionTypes[28] = "Estate distribution";
    transactionTypes[29] = " Exercised options";
    transactionTypes[30] = " Inheritance";
    transactionTypes[31] = "End date options";
    transactionTypes[32] = "Dividend";
    transactionTypes[33] = "Bonus issue";
    transactionTypes[34] = "Fusion";
    transactionTypes[35] = "Withdrawal";
    transactionTypes[36] = "Division of matrimonial property";
    transactionTypes[37] = "New related party";
    transactionTypes[38] = "Yield";
    transactionTypes[39] = "Class change";
    transactionTypes[40] = "Distribution";
    transactionTypes[41] = "Acquisition";
    transactionTypes[42] = "Share future";
    transactionTypes[43] = "Redemption of futures";
    transactionTypes[44] = "Withdrawal";
    transactionTypes[45] = "Sale";
    transactionTypes[46] = "Interna överf VPC";
    transactionTypes[47] = "Refund";
    transactionTypes[48] = "Conversion";
    transactionTypes[49] = "Fission";
    transactionTypes[50] = "Utbyte";
    transactionTypes[51] = "Subordinated loan";
    transactionTypes[52] = "Övrig förändring";
    transactionTypes[53] = "Avslut av insyn";

    commentTypes["makulerad"] = "Cancelled";
    commentTypes["reviderad"] = "Revised";


    holderTypes[1] = "Own";
    holderTypes[2] = "Spouse";
    holderTypes[3] = "Legal person";
    holderTypes[4] = "Child";
    holderTypes[5] = "Related party";
    holderTypes[6] = "Cohabitee";


    positionTypes[1] = "MD";
    positionTypes[2] = "MD subsidiary";
    positionTypes[3] = "MD parent firm";
    positionTypes[4] = "Deputy MD";
    positionTypes[5] = "Deputy MD subsidiary";
    positionTypes[6] = "Deputy MD parent firm";
    positionTypes[7] = "Board member";
    positionTypes[8] = "Board member subsidiary";
    positionTypes[9] = "Board member parent firm";
    positionTypes[10] = " Alt. board member ";
    positionTypes[11] = " Alt. board member subsidiary";
    positionTypes[12] = "Alt. board member parent firm";
    positionTypes[13] = "Auditor";
    positionTypes[14] = "Auditor subsidiary";
    positionTypes[15] = "Auditor parent firm";
    positionTypes[16] = "Deputy Auditor";
    positionTypes[17] = "Deputy Auditor subsidiary";
    positionTypes[18] = "Deputy Auditor parent firm";
    positionTypes[19] = "Larger Shareholder";
    positionTypes[20] = "Other position";
    positionTypes[21] = "Other position subsidiary";
    positionTypes[22] = "Other position parent firm";
    positionTypes[23] = "Listed company";


    securityTypes[1] = "Share";
    securityTypes[2] = "Share  PR";
    securityTypes[3] = "Call option";
    securityTypes[4] = "Put option";
    securityTypes[5] = "Stock futures ";
    securityTypes[6] = "Synthetic option";
    securityTypes[7] = "American depository receipts";
    securityTypes[8] = "Swedish depository receipts ";
    securityTypes[9] = "Convertible";
    securityTypes[10] = "Payed subscribed share";
    securityTypes[11] = "Interim share";
    securityTypes[12] = "Payed subscribed unit";
    securityTypes[13] = "Unit right";
    securityTypes[14] = "Subscription right, share";
    securityTypes[15] = "Subscribed option";
    securityTypes[16] = "Option receipts ";
    securityTypes[17] = "Redemption right";
    securityTypes[18] = "Special right";
    securityTypes[19] = "other derivat";
    securityTypes[20] = "Delbevis";
    securityTypes[21] = "Interest bearing security";
    securityTypes[22] = "Redemption share";
    securityTypes[23] = "Convertible participation certificates";
    securityTypes[24] = "Sale right";
    securityTypes[25] = "Interim certificates";
    securityTypes[26] = "Delrätt, aktie";
    securityTypes[27] = "Payed subscribed convertible";
    securityTypes[28] = "Subordinated loan";
    securityTypes[29] = " Indicates 0 holdings";

    return {
        positionTypes: positionTypes,
        holderTypes: holderTypes,
        securityTypes: securityTypes,
        transactionTypes: transactionTypes,
        commentTypes: commentTypes
    };
}(jQuery);

cision.websolution.texts["fi"].insidersDescriptions = function () {
    var transactionTypes = [];
    var positionTypes = [];
    var holderTypes = [];
    var securityTypes = [];
    var commentTypes = [];

    transactionTypes[0] = "Syy tuntematon kirjaushetkellä.";
    transactionTypes[1] = "Omistusosuuksien ilmoittaminen";
    transactionTypes[2] = "Osto";
    transactionTypes[3] = "Myynti";
    transactionTypes[4] = "Korjaus ylöspäin";
    transactionTypes[5] = "Korjaus alaspäin";
    transactionTypes[6] = "Muunnos +";
    transactionTypes[7] = "Muunnos -";
    transactionTypes[8] = "Erääntyminen";
    transactionTypes[9] = "Osakeanti";
    transactionTypes[10] = "Osakeinvestointisuunnitelma";
    transactionTypes[11] = "Tilaus";
    transactionTypes[12] = "Osinko";
    transactionTypes[13] = "Luopuminen";
    transactionTypes[14] = "Lahja";
    transactionTypes[15] = "Poikkeus";
    transactionTypes[16] = "Jakaminen";
    transactionTypes[17] = "Yhdistely";
    transactionTypes[18] = "Siirto";
    transactionTypes[19] = "Liikkeeseen laskettu optio";
    transactionTypes[20] = "Avaussaldo";
    transactionTypes[21] = "Muunnos";
    transactionTypes[22] = "Uudelleen luokitus";
    transactionTypes[23] = "Lunastaminen";
    transactionTypes[24] = "Osakelaina";
    transactionTypes[25] = "Erääntyminen";
    transactionTypes[26] = "Osakkeiden uusanti";
    transactionTypes[27] = "Liikkeeseenlasku luontoisetuna";
    transactionTypes[28] = "Pesänjako";
    transactionTypes[29] = " Käytetyt optiot";
    transactionTypes[30] = " Perintö";
    transactionTypes[31] = "Päättymispäivä optiot";
    transactionTypes[32] = "Osinko";
    transactionTypes[33] = "Ilmaisanti";
    transactionTypes[34] = "Fuusio";
    transactionTypes[35] = "Luopuminen";
    transactionTypes[36] = "Ositus";
    transactionTypes[37] = "Uusi lähipiiriin kuuluva";
    transactionTypes[38] = "Tuotto";
    transactionTypes[39] = "Luokan muutos";
    transactionTypes[40] = "Jakelu";
    transactionTypes[41] = "Hankinta";
    transactionTypes[42] = "Osakefutuuri";
    transactionTypes[43] = "Futuureiden lunastaminen";
    transactionTypes[44] = "Luopuminen";
    transactionTypes[45] = "Myynti";
    transactionTypes[46] = "Sisäiset siirrot arvo-osuusrekistereihin";
    transactionTypes[47] = "Hyvitys";
    transactionTypes[48] = "Muunnos";
    transactionTypes[49] = "Jakautuminen";
    transactionTypes[50] = "Vaihto";
    transactionTypes[51] = "Pääomalaina";
    transactionTypes[52] = "Muu muutos";
    transactionTypes[53] = "Tarkastustulos";

    commentTypes["makulerad"] = "Cancelled";
    commentTypes["reviderad"] = "Revised";


    holderTypes[1] = "Oma";
    holderTypes[2] = "Puoliso";
    holderTypes[3] = "Juridinen henkilö";
    holderTypes[4] = "Lapsi";
    holderTypes[5] = "Lähipiiriin kuuluva";
    holderTypes[6] = "Avopuoliso";


    positionTypes[1] = "Toimitusjohtaja";
    positionTypes[2] = "Toimitusjohtaja tytäryhtiö";
    positionTypes[3] = "Toimitusjohtaja emoyhtiö";
    positionTypes[4] = "Varatoimitusjohtaja";
    positionTypes[5] = "Varatoimitusjohtaja tytäryhtiö";
    positionTypes[6] = "Varatoimitusjohtaja emoyhtiö";
    positionTypes[7] = "Hallituksen jäsen";
    positionTypes[8] = "Hallituksen jäsen tytäryhtiö";
    positionTypes[9] = "Hallituksen jäsen emoyhtiö";
    positionTypes[10] = "Hallituksen varajäsen";
    positionTypes[11] = "Hallituksen varajäsen tytäryhtiö";
    positionTypes[12] = "Hallituksen varajäsen emoyhtiö";
    positionTypes[13] = "Tilintarkastaja";
    positionTypes[14] = "Tilintarkastaja tytäryhtiö";
    positionTypes[15] = "Tilintarkastaja emoyhtiö";
    positionTypes[16] = "Varatilintarkastaja";
    positionTypes[17] = "Varatilintarkastaja tytäryhtiö";
    positionTypes[18] = "Varatilintarkastaja emoyhtiö";
    positionTypes[19] = "Merkittävä osakkeenomistaja";
    positionTypes[20] = "Muu asema";
    positionTypes[21] = "Muu asema tytäryhtiö";
    positionTypes[22] = "Muu asema emoyhtiö";
    positionTypes[23] = "Listattu yhtiö";


    securityTypes[1] = "Osake";
    securityTypes[2] = "Osake  PR";
    securityTypes[3] = "Osto-optio";
    securityTypes[4] = "Myyntioptio";
    securityTypes[5] = "Osakefutuurit";
    securityTypes[6] = "Synteettinen optio";
    securityTypes[7] = "ADR-todistukset";
    securityTypes[8] = "Swedish depository receipts ";
    securityTypes[9] = "Vaihtovelkakirja";
    securityTypes[10] = "Maksettu osakemerkintä";
    securityTypes[11] = "Väliaikainen osake";
    securityTypes[12] = "Maksettu merkintäosuus";
    securityTypes[13] = "Sijoitusrahasto-osuus";
    securityTypes[14] = "Merkintäoikeus, osake";
    securityTypes[15] = "Merkitty option";
    securityTypes[16] = "Optiotodistukset";
    securityTypes[17] = "Lunastusoikeus";
    securityTypes[18] = "Eritysoikeus";
    securityTypes[19] = "muu johdannainen";
    securityTypes[20] = "Osatodistus";
    securityTypes[21] = "Korkoa tuottava arvopaperi";
    securityTypes[22] = "Lunastus osake";
    securityTypes[23] = "Vaihdettavat sijoitustodistukset";
    securityTypes[24] = "Myyntioikeus";
    securityTypes[25] = "Väliaikaistodistukset";
    securityTypes[26] = "Osaoikeus, osake";
    securityTypes[27] = "Maksettu vaihtovelkakirjan merkintä";
    securityTypes[28] = "Pääomalaina";
    securityTypes[29] = "Osoittaa 0 omistusta";

    return {
        positionTypes: positionTypes,
        holderTypes: holderTypes,
        securityTypes: securityTypes,
        transactionTypes: transactionTypes,
        commentTypes: commentTypes
    };
}(jQuery);

cision.websolution.texts["no"].insidersDescriptions = function () {
    var transactionTypes = [];
    var positionTypes = [];
    var holderTypes = [];
    var securityTypes = [];
    var commentTypes = [];

    transactionTypes[0] = "Årsak ukjent ved registering.";
    transactionTypes[1] = "Beholdningsvarsling";
    transactionTypes[2] = "Kjøp";
    transactionTypes[3] = "Salg";
    transactionTypes[4] = "Korrigering, opp";
    transactionTypes[5] = "Korrigering, ned";
    transactionTypes[6] = "Konvertering +";
    transactionTypes[7] = "Konvertering -";
    transactionTypes[8] = "Modenhet";
    transactionTypes[9] = "Fordeling";
    transactionTypes[10] = "Investeringsplan for aksje";
    transactionTypes[11] = "Abonnement";
    transactionTypes[12] = "Utbytte";
    transactionTypes[13] = "Uttak";
    transactionTypes[14] = "Gave";
    transactionTypes[15] = "Unntak";
    transactionTypes[16] = "Splitt";
    transactionTypes[17] = "Omvendt splitt";
    transactionTypes[18] = "Overføring";
    transactionTypes[19] = "Utstedt opsjon";
    transactionTypes[20] = "Åpningsbalanse";
    transactionTypes[21] = "Konvertering";
    transactionTypes[22] = "Reklassifisering";
    transactionTypes[23] = "Innløsning";
    transactionTypes[24] = "Aksjelån";
    transactionTypes[25] = "Modenhet";
    transactionTypes[26] = "Ny aksjeemisjon";
    transactionTypes[27] = "Utstedelse in natura";
    transactionTypes[28] = "Eiendomsdistribusjon";
    transactionTypes[29] = "Innfrielsesalternativer";
    transactionTypes[30] = "Arv";
    transactionTypes[31] = "Sluttdato-opsjoner";
    transactionTypes[32] = "Utbytte";
    transactionTypes[33] = "Bonusutstedelse";
    transactionTypes[34] = "Fusjon";
    transactionTypes[35] = "Uttak";
    transactionTypes[36] = "Deling av felleseie";
    transactionTypes[37] = "Ny relatert selskap";
    transactionTypes[38] = "Resultat";
    transactionTypes[39] = "Klasseendring";
    transactionTypes[40] = "Dirstribusjon";
    transactionTypes[41] = "Anskaffelse";
    transactionTypes[42] = "Aksje, future";
    transactionTypes[43] = "Innløsning av futures";
    transactionTypes[44] = "Uttak";
    transactionTypes[45] = "Salg";
    transactionTypes[46] = "Intern overf. VPC";
    transactionTypes[47] = "Refusjon";
    transactionTypes[48] = "Konvertering";
    transactionTypes[49] = "Fisjon";
    transactionTypes[50] = "Utbytte";
    transactionTypes[51] = "Ansvarlig lån";
    transactionTypes[52] = "Øvrig forandring";
    transactionTypes[53] = "Avslutning av innsyn";

    commentTypes["makulerad"] = "Cancelled";
    commentTypes["reviderad"] = "Revised";


    holderTypes[1] = "Egen";
    holderTypes[2] = "Partner";
    holderTypes[3] = "Juridisk person";
    holderTypes[4] = "Barn";
    holderTypes[5] = "Relatert selskap";
    holderTypes[6] = "Samboer";


    positionTypes[1] = "Adm.dir.";
    positionTypes[2] = "Adm. dir. datterselskap";
    positionTypes[3] = "Adm. dir. morselskap";
    positionTypes[4] = "Viseadm. dir.";
    positionTypes[5] = "Viseadm. dir. datterselskap";
    positionTypes[6] = "Viseadm. dir. morselskap";
    positionTypes[7] = "Styremedlem";
    positionTypes[8] = "Styremedlem datterselskap";
    positionTypes[9] = "Styremedlem morselskap";
    positionTypes[10] = "Varamedlem styre";
    positionTypes[11] = "Varamedlem styre datterselskap";
    positionTypes[12] = "Varamedlem styre morselskap";
    positionTypes[13] = "Revisor";
    positionTypes[14] = "Revisor datterselskap";
    positionTypes[15] = "Revisor morselskap";
    positionTypes[16] = "Stedfortredende revisor";
    positionTypes[17] = "Stedfortredende revisor datterselskap";
    positionTypes[18] = "Stedfortredende revisor morselskap";
    positionTypes[19] = "Større aksjonær";
    positionTypes[20] = "Annen posisjon";
    positionTypes[21] = "Annen posisjon datterselskap";
    positionTypes[22] = "Annen posisjon morselskap";
    positionTypes[23] = "Børsnotert selskap";


    securityTypes[1] = "Aksje";
    securityTypes[2] = "Aksje PR";
    securityTypes[3] = "Kjøpsopsjon";
    securityTypes[4] = "Salgsopsjon";
    securityTypes[5] = "Framtidig aksjeportefølje ";
    securityTypes[6] = "Syntetisk opsjon";
    securityTypes[7] = "Amerikanske depotbevis";
    securityTypes[8] = "Swedish depository receipts ";
    securityTypes[9] = "Konverterbart";
    securityTypes[10] = "Betalt abonnert aksje";
    securityTypes[11] = "Mellomaksje";
    securityTypes[12] = "Betalt abonnert enhet";
    securityTypes[13] = "Enhetsrettighet";
    securityTypes[14] = "Abonneringsrettinghet, aksje";
    securityTypes[15] = "Abonnert opsjon";
    securityTypes[16] = "Opsjonskvitteringer ";
    securityTypes[17] = "Innløsningsrettigheter";
    securityTypes[18] = "Spesielle rettigheter";
    securityTypes[19] = "Andre derivater";
    securityTypes[20] = "Delbevis";
    securityTypes[21] = "Rentebærende verdipapir";
    securityTypes[22] = "Innløsingsaksjer";
    securityTypes[23] = "Konvertebare deltakersertfikater";
    securityTypes[24] = "Salgsrettigheter";
    securityTypes[25] = "Midlertidige sertifikater";
    securityTypes[26] = "Delrett, aksje";
    securityTypes[27] = "Betalt abonnert enhet";
    securityTypes[28] = "Ansvarlig lån";
    securityTypes[29] = "Indikerer 0 andeler";

    return {
        positionTypes: positionTypes,
        holderTypes: holderTypes,
        securityTypes: securityTypes,
        transactionTypes: transactionTypes,
        commentTypes: commentTypes
    };
}(jQuery);

cision.websolution.texts["dk"].insidersDescriptions = function () {
    var transactionTypes = [];
    var positionTypes = [];
    var holderTypes = [];
    var securityTypes = [];
    var commentTypes = [];

    transactionTypes[0] = "Årsag ukendt på reg.tidspunkt.";
    transactionTypes[1] = "Indberetning af aktiebeholdning";
    transactionTypes[2] = "Køb";
    transactionTypes[3] = "Salg";
    transactionTypes[4] = "Korrektion op";
    transactionTypes[5] = "Korrektion ned";
    transactionTypes[6] = "Konvertering +";
    transactionTypes[7] = "Konvertering -";
    transactionTypes[8] = "Udløbsdato";
    transactionTypes[9] = "Pulje (allotment)";
    transactionTypes[10] = "Aktie investerings plan";
    transactionTypes[11] = "Tegning";
    transactionTypes[12] = "Udbytte";
    transactionTypes[13] = "Tilbagekaldelse";
    transactionTypes[14] = "Gave";
    transactionTypes[15] = "Dispensation";
    transactionTypes[16] = "Aktiesplit";
    transactionTypes[17] = "Omvendt aktiesplit";
    transactionTypes[18] = "Overførsel";
    transactionTypes[19] = "Udstedt option";
    transactionTypes[20] = "Åbningsbalance";
    transactionTypes[21] = "Konvertering";
    transactionTypes[22] = "Omgruppering";
    transactionTypes[23] = "Indfrielse";
    transactionTypes[24] = "Aktielån";
    transactionTypes[25] = "Udløbsdato";
    transactionTypes[26] = "Ny aktieudstedelse";
    transactionTypes[27] = "Udstedelsestype";
    transactionTypes[28] = "Formuefordeling";
    transactionTypes[29] = "Aftalte optioner";
    transactionTypes[30] = "Arv";
    transactionTypes[31] = "Udløbsdato optioner";
    transactionTypes[32] = "Udbytte";
    transactionTypes[33] = "Emission af fondsaktier";
    transactionTypes[34] = "Fusion";
    transactionTypes[35] = "Tilbagekaldelse";
    transactionTypes[36] = "Opdeling af ægteskabelig formue";
    transactionTypes[37] = "Nyt partnerskab";
    transactionTypes[38] = "Afkast";
    transactionTypes[39] = "Ændring af klasse";
    transactionTypes[40] = "Fordeling";
    transactionTypes[41] = "Erhvervelse";
    transactionTypes[42] = "Aktiefuture";
    transactionTypes[43] = "Indfrielse af futures";
    transactionTypes[44] = "Tilbagekaldelse";
    transactionTypes[45] = "Salg";
    transactionTypes[46] = "Intern overf. VPC (Sveriges Værdipapircentral)";
    transactionTypes[47] = "Refundering";
    transactionTypes[48] = "Konvertering";
    transactionTypes[49] = "Spaltning";
    transactionTypes[50] = "Utbytte";
    transactionTypes[51] = "Efterstillet lån";
    transactionTypes[52] = "Øvrige ændringer";
    transactionTypes[53] = "Afslutning af indsigt";

    commentTypes["makulerad"] = "Cancelled";
    commentTypes["reviderad"] = "Revised";


    holderTypes[1] = "Eget";
    holderTypes[2] = "Ægtefælle";
    holderTypes[3] = "Juridisk person";
    holderTypes[4] = "Barn";
    holderTypes[5] = "Beslægtet person";
    holderTypes[6] = "Samboende";


    positionTypes[1] = "Adm. direktør";
    positionTypes[2] = "Adm. direktør, datterselskab";
    positionTypes[3] = "Direktør, moderselskab";
    positionTypes[4] = "Vicedirektør";
    positionTypes[5] = "Vicedirektør, datterselskab";
    positionTypes[6] = "Adm. direktør, moderselskab";
    positionTypes[7] = "Bestyrelsesmedlem";
    positionTypes[8] = "Bestyrelsesmedlem, datterselskab";
    positionTypes[9] = "Bestyrelsesmedlem, moderselskab";
    positionTypes[10] = "Alternativt bestyrelsesmedlem";
    positionTypes[11] = "Alternativt bestyrelsesmedlem, datterselskab";
    positionTypes[12] = "Alternativt bestyrelsesmedlem, moderselskab";
    positionTypes[13] = "Revisor";
    positionTypes[14] = "Revisor, datterselskab";
    positionTypes[15] = "Revisor, moderselskab";
    positionTypes[16] = "Assisterende revisor";
    positionTypes[17] = "Assisterende revisor, datterselskab";
    positionTypes[18] = "Assisterende revisor, moderselskab";
    positionTypes[19] = "Indehaver af større aktiebeholdning";
    positionTypes[20] = "Anden stilling";
    positionTypes[21] = "Anden stilling, datterselskab";
    positionTypes[22] = "Anden stilling, moderselskab";
    positionTypes[23] = "Børsnoteret selskab";


    securityTypes[1] = "Aktie";
    securityTypes[2] = "Aktie, købsanmodning";
    securityTypes[3] = "Købsrettighed (call option)";
    securityTypes[4] = "Salgsrettighed (put option)";
    securityTypes[5] = "Aktieoptioner ";
    securityTypes[6] = "Syntetisk option";
    securityTypes[7] = "Kvitteringer fra amerikansk værdipapircentral";
    securityTypes[8] = "Swedish depository receipts ";
    securityTypes[9] = "Konvertibel";
    securityTypes[10] = "Betalt tegnet aktie";
    securityTypes[11] = "Interim-aktie";
    securityTypes[12] = "Betalt tegnet enhed";
    securityTypes[13] = "Enhed, rettighed";
    securityTypes[14] = "Tegningsret, aktie";
    securityTypes[15] = "Tegnet option";
    securityTypes[16] = "Optionskvitteringer";
    securityTypes[17] = "Indfrielsesret";
    securityTypes[18] = "Særrettighed";
    securityTypes[19] = "andre afledte aktiver";
    securityTypes[20] = "Delbevis";
    securityTypes[21] = "Rentebærende værdipapir";
    securityTypes[22] = "Indfrielsesaktie";
    securityTypes[23] = "Konvertible deltagelsesbeviser";
    securityTypes[24] = "Salgsrettighed";
    securityTypes[25] = "Interim-beviser";
    securityTypes[26] = "Delret, aktie";
    securityTypes[27] = "Betalt tegnet konvertibel";
    securityTypes[28] = "Efterstillet lån";
    securityTypes[29] = "Indikerer 0 investeringer";

    return {
        positionTypes: positionTypes,
        holderTypes: holderTypes,
        securityTypes: securityTypes,
        transactionTypes: transactionTypes,
        commentTypes: commentTypes
    };
}(jQuery);

cision.websolution.texts["de"].insidersDescriptions = function () {
    var transactionTypes = [];
    var positionTypes = [];
    var holderTypes = [];
    var securityTypes = [];
    var commentTypes = [];

    //incomplete translation 90% in english

    transactionTypes[0] = "Grund zum Zeitpunkt der Reg. unbekannt";
    transactionTypes[1] = "Holding-Mitteilung";
    transactionTypes[2] = "Kauf, Einkauf";
    transactionTypes[3] = "Verkauf";
    transactionTypes[4] = "Korrektur nach oben";
    transactionTypes[5] = "Korrektur nach unten";
    transactionTypes[6] = "Umwandlung +";
    transactionTypes[7] = "Umwandllung -";
    transactionTypes[8] = "Ablauf";
    transactionTypes[9] = "Zuteilung";
    transactionTypes[10] = "Aktien Investitions plan";
    transactionTypes[11] = "Abonnement";
    transactionTypes[12] = "Dividende";
    transactionTypes[13] = "Withdrawal";
    transactionTypes[14] = "Gift";
    transactionTypes[15] = "Exemption";
    transactionTypes[16] = "Split";
    transactionTypes[17] = "Reverse split";
    transactionTypes[18] = "Transfer";
    transactionTypes[19] = "Issued option";
    transactionTypes[20] = "Opening balance";
    transactionTypes[21] = "Conversion";
    transactionTypes[22] = "Reclassification";
    transactionTypes[23] = "Redemption";
    transactionTypes[24] = "Share loan";
    transactionTypes[25] = "Maturity";
    transactionTypes[26] = "New Share issue";
    transactionTypes[27] = "Issue in kind";
    transactionTypes[28] = "Estate distribution";
    transactionTypes[29] = " Exercised options";
    transactionTypes[30] = " Inheritance";
    transactionTypes[31] = "End date options";
    transactionTypes[32] = "Dividend";
    transactionTypes[33] = "Bonus issue";
    transactionTypes[34] = "Fusion";
    transactionTypes[35] = "Withdrawal";
    transactionTypes[36] = "Division of matrimonial property";
    transactionTypes[37] = "New related party";
    transactionTypes[38] = "Yield";
    transactionTypes[39] = "Class change";
    transactionTypes[40] = "Distribution";
    transactionTypes[41] = "Acquisition";
    transactionTypes[42] = "Share future";
    transactionTypes[43] = "Redemption of futures";
    transactionTypes[44] = "Withdrawal";
    transactionTypes[45] = "Sale";
    transactionTypes[46] = "Interna överf VPC";
    transactionTypes[47] = "Refund";
    transactionTypes[48] = "Conversion";
    transactionTypes[49] = "Fission";
    transactionTypes[50] = "Utbyte";
    transactionTypes[51] = "Subordinated loan";
    transactionTypes[52] = "Övrig förändring";
    transactionTypes[53] = "Avslut av insyn";

    commentTypes["makulerad"] = "Cancelled";
    commentTypes["reviderad"] = "Revised";

    holderTypes[1] = "Own";
    holderTypes[2] = "Spouse";
    holderTypes[3] = "Legal person";
    holderTypes[4] = "Child";
    holderTypes[5] = "Related party";
    holderTypes[6] = "Cohabitee";


    positionTypes[1] = "MD";
    positionTypes[2] = "MD subsidiary";
    positionTypes[3] = "MD parent firm";
    positionTypes[4] = "Deputy MD";
    positionTypes[5] = "Deputy MD subsidiary";
    positionTypes[6] = "Deputy MD parent firm";
    positionTypes[7] = "Board member";
    positionTypes[8] = "Board member subsidiary";
    positionTypes[9] = "Board member parent firm";
    positionTypes[10] = " Alt. board member ";
    positionTypes[11] = " Alt. board member subsidiary";
    positionTypes[12] = "Alt. board member parent firm";
    positionTypes[13] = "Auditor";
    positionTypes[14] = "Auditor subsidiary";
    positionTypes[15] = "Auditor parent firm";
    positionTypes[16] = "Deputy Auditor";
    positionTypes[17] = "Deputy Auditor subsidiary";
    positionTypes[18] = "Deputy Auditor parent firm";
    positionTypes[19] = "Larger Shareholder";
    positionTypes[20] = "Other position";
    positionTypes[21] = "Other position subsidiary";
    positionTypes[22] = "Other position parent firm";
    positionTypes[23] = "Listed company";


    securityTypes[1] = "Share";
    securityTypes[2] = "Share  PR";
    securityTypes[3] = "Call option";
    securityTypes[4] = "Put option";
    securityTypes[5] = "Stock futures ";
    securityTypes[6] = "Synthetic option";
    securityTypes[7] = "American depository receipts";
    securityTypes[8] = "Swedish depository receipts ";
    securityTypes[9] = "Convertible";
    securityTypes[10] = "Payed subscribed share";
    securityTypes[11] = "Interim share";
    securityTypes[12] = "Payed subscribed unit";
    securityTypes[13] = "Unit right";
    securityTypes[14] = "Subscription right, share";
    securityTypes[15] = "Subscribed option";
    securityTypes[16] = "Option receipts ";
    securityTypes[17] = "Redemption right";
    securityTypes[18] = "Special right";
    securityTypes[19] = "other derivat";
    securityTypes[20] = "Delbevis";
    securityTypes[21] = "Interest bearing security";
    securityTypes[22] = "Redemption share";
    securityTypes[23] = "Convertible participation certificates";
    securityTypes[24] = "Sale right";
    securityTypes[25] = "Interim certificates";
    securityTypes[26] = "Delrätt, aktie";
    securityTypes[27] = "Payed subscribed convertible";
    securityTypes[28] = "Subordinated loan";
    securityTypes[29] = " Indicates 0 holdings";

    return {
        positionTypes: positionTypes,
        holderTypes: holderTypes,
        securityTypes: securityTypes,
        transactionTypes: transactionTypes,
        commentTypes: commentTypes
    };
}(jQuery);

cision.websolution.texts["en"].totalReturnDescriptions = function () {
    var intervalKeys = {};

    intervalKeys["LAST_03_MONTH"] = "Last 3 months";
    intervalKeys["LAST_06_MONTH"] = "Last 6 months";
    intervalKeys["LAST_12_MONTH"] = "Last 12 months";
    intervalKeys["LAST_03_YEAR"] = "Last 3 years";
    intervalKeys["LAST_05_YEAR"] = "Last 5 years";
    intervalKeys["LAST_10_YEAR"] = "Last 10 years";
    intervalKeys["LAST_15_YEAR"] = "Last 15 years";
    intervalKeys["LAST_20_YEAR"] = "Last 20 years";
    intervalKeys["LAST_25_YEAR"] = "Last 25 years";
    intervalKeys["LAST_00_ALL"] = "All";
    intervalKeys["ALL"] = "All";

    intervalKeys["BTN_03_MONTH"] = "3 MONTH";
    intervalKeys["BTN_06_MONTH"] = "6 MONTH";
    intervalKeys["BTN_12_MONTH"] = "12 MONTH";
    intervalKeys["BTN_01_YEAR"] = "1 YEAR";
    intervalKeys["BTN_03_YEAR"] = "3 YEAR";
    intervalKeys["BTN_05_YEAR"] = "5 YEAR";
    intervalKeys["BTN_10_YEAR"] = "10 YEAR";
    intervalKeys["BTN_15_YEAR"] = "15 YEAR";
    intervalKeys["BTN_20_YEAR"] = "20 YEAR";
    intervalKeys["BTN_25_YEAR"] = "25 YEAR";
    intervalKeys["BTN_ALL"] = "ALL";

    var informationParagraphs = [
        {
            title: "Total return",
            content: "Return for shareholders is best measured in terms of total return. Total return is defined as share development including reinvested dividends. The return over a given period will therefore be the development of the share added with the dividends made during the period. The dividend is calculated as reinvested on the day the share is traded excluding the right to dividend (the x-day). Total return can be presented as a percentage or in a certain currency."
        }, {
        //    title: "Average annual total return",
        //    content: "Total return can also be expressed as an annual average for a certain period of time."
        //}, {
            title: "Adjusted dividend",
            content: "Adjusted dividend is the dividend’s value adjusted for emissions and splits. Example: In 2006, SEK 10 per share is distributed to the owners. In 2010, a split is conducted which gives the owners two shares for each old share. The dividend of SEK 10 in 2006 is re-calculated taking into account that the owners today have twice as many shares as compared to the date of dividend. The adjusted dividend will in the example be SEK 5 per share."
        }, {
            title: "Trade and instruments",
            content: "For information about trade and various instruments, please refer to the Nasdaq OMX Stockholm website."
        }
    ];

    var titles = {
        Overview: 'Overview',
        TotalReturn: 'Total Return',
        TotalReturnCagr: 'Average annual return',
        Dividend: 'Dividend',
        DividendUnAdjusted: 'Dividend (unadjusted)',
        DividendAdjusted: 'Dividend (adjusted)',
        DividendType: 'Comment',
        DividendType_Annual: 'Ordinary',
        DividendType_Bonus: 'Extraordinary dividend',
        Price: 'Listed Price',
        Year: 'Year',

        DetailCustomPeriodTitle: 'Change during the selected period',
        DetailGenericListingTitle: 'Total return per period, %',
        DetailCagrListingTitle: 'Average annual total return per period, %',
        Information: 'Information'
    };

    return {
        titles: titles,
        informationParagraphs: informationParagraphs,
        intervalKeys: intervalKeys
    };
}(jQuery);

cision.websolution.texts["sv"].totalReturnDescriptions = function () {
    var intervalKeys = {};

    intervalKeys["LAST_03_MONTH"] = "Senaste 3 månader";
    intervalKeys["LAST_06_MONTH"] = "Senaste 6 månader";
    intervalKeys["LAST_12_MONTH"] = "Senaste 12 månader";
    intervalKeys["LAST_03_YEAR"] = "Senaste 3 åren";
    intervalKeys["LAST_05_YEAR"] = "Senaste 5 åren";
    intervalKeys["LAST_10_YEAR"] = "Senaste 10 åren";
    intervalKeys["LAST_15_YEAR"] = "Senaste 15 åren";
    intervalKeys["LAST_20_YEAR"] = "Senaste 20 åren";
    intervalKeys["LAST_25_YEAR"] = "Senaste 25 åren";
    intervalKeys["LAST_00_ALL"] = "Allt";
    intervalKeys["ALL"] = "Allt";

    intervalKeys["BTN_03_MONTH"] = "3 MÅNAD";
    intervalKeys["BTN_06_MONTH"] = "6 MÅNAD";
    intervalKeys["BTN_12_MONTH"] = "12 MÅNAD";
    intervalKeys["BTN_01_YEAR"] = "1 ÅR";
    intervalKeys["BTN_03_YEAR"] = "3 ÅR";
    intervalKeys["BTN_05_YEAR"] = "5 ÅR";
    intervalKeys["BTN_10_YEAR"] = "10 ÅR";
    intervalKeys["BTN_15_YEAR"] = "15 ÅR";
    intervalKeys["BTN_20_YEAR"] = "20 ÅR";
    intervalKeys["BTN_25_YEAR"] = "25 ÅR";
    intervalKeys["BTN_ALL"] = "ALLT";

    var informationParagraphs = [
        {
            title: "Totalavkastning",
            content: "Avkastning för aktieägare, mäts med fördel i form av totalavkastning. Totalavkastning defineras som aktiekursutveckling inklusive återinvesterad utdelning. Avkastningen under en given period blir därmed aktiekursens utveckling med tillägg av de utdelningar som skett under perioden. Utdelningen beräknas som återinvesterad den dagen aktien handlas exklusive rätt till utdelning (x-dagen). Totalavkastning kan presenteras i procent eller i viss valuta."
        }, {
        //    title: "Genomsnittlig årlig totalavkastning",
        //    content: "Totalavkastning kan även uttryckas som ett årligt genomsnitt för en bestämd tidsperiod."
        //}, {
            title: "Justerad utdelning",
            content: "Justerad utdelning är utdelningens värde justerat för emissioner och splittar. Exempel: År 2006 delas 10 kr per aktie ut till ägarna. År 2010 genomförds en split som ger ägarna två aktier för varje gammal aktie. Utdelningen om 10 kr 2006 beräknas om med hänsyn till att ägarna idag har dubbelt så många aktier jämfört med tidpunkten för utdelningen. Den justerade utdelningen blir i exemplet 5 kr per aktie."
        }, {
            title: "Handel och instrument",
            content: "För information om handel och olika instrument hänvisas till Nasdaq OMX Stockholms webbplats."
        }
    ];

    var titles = {
        Overview: 'Översikt',
        TotalReturn: 'Totalavkastning',
        TotalReturnCagr: 'Genomsnittlig årlig totalavkastning',
        Dividend: 'Utdelning',
        DividendUnAdjusted: 'Utdelning (ojusterad)',
        DividendAdjusted: 'Utdelning (justerad)',
        DividendType: 'Kommentar',
        DividendType_Annual: 'Ordinarie',
        DividendType_Bonus: 'Extra utdelning',
        Price: 'Aktiekurs',
        Year: 'År',

        DetailCustomPeriodTitle: 'Förändring under vald period',
        DetailGenericListingTitle: 'Totalavkastning per period, %',
        DetailCagrListingTitle: 'Genomsnittlig årlig totalavkastning per period, %',
        Information: 'Information'
    };

    return {
        titles: titles,
        informationParagraphs: informationParagraphs,
        intervalKeys: intervalKeys
    };
}(jQuery);